import { FC, useCallback, useState } from "react";
import { AgGridTable } from "../../utils/agGridTable/AgGridTable";
const Minuta: FC = () => {
    const evento =(e:any)=>{        
    }
    const [columnDefs] = useState([
        { field: 'make',headerName:"Marca",minWidth:200, maxWidth:200},
        { field: 'model' },
        { field: 'price' },
        {
            field: 'gender',
            cellRenderer: (params:any)=>{
                return (<>
                    <input type="text" defaultValue={params.value} onBlur={evento}></input>
                </>)
            },
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true
        },
    ]);
    const [dataRow] = useState([
        { make: 'Toyota', model: 'Celica', price: 35000, gender: 'Masculino' },
        { make: 'Ford', model: 'Mondeo', price: 32000, gender: 'Masculino' },
        { make: 'Porsche', model: 'Boxter', price: 72000, gender: 'Femenino' },
        { make: 'Porsche 2', model: 'Boxter 2', price: 72002, gender: 'Masculino' },
        { make: 'Porsche 3', model: 'Boxter 3', price: 72003, gender: 'Masculino' },
        { make: 'Porsche 4', model: 'Boxter 4', price: 72004, gender: 'Femenino' },
        { make: 'Porsche 5', model: 'Boxter 5', price: 72005, gender: 'Masculino' },
        { make: 'Porsche 6', model: 'Boxter 6', price: 72006, gender: 'Masculino' },
        { make: 'Porsche 7', model: 'Boxter 7', price: 72007, gender: 'Femenino' },
        { make: 'Porsche 8', model: 'Boxter 8', price: 72008, gender: 'Femenino' },
        { make: 'Porsche 9', model: 'Boxter 9', price: 72009, gender: 'Femenino' },
        { make: 'Porsche 10', model: 'Boxter 10', price: 72010, gender: 'Masculino' }
    ]);
    return (
        <>
            <AgGridTable
                columnDefs={columnDefs}
                dataRow={dataRow}
            />
        </>
    )
}
export { Minuta }